
import axios from 'axios';
import DepartmentCostPane from './DepartmentCostPane.vue';
import fileDownload from 'js-file-download';
import {nextTick} from 'vue';

export default {
  name: 'OrderingCost',

  components: {DepartmentCostPane},

  props: {
    yearProp: {type: Number, required: true},
    dataUrl: {type: String, required: true},
    detailsUrl: {type: String, required: true},
    downloadUrl: {type: String, required: true},
  },

  data() {
    return {
      year: this.yearProp,

      currentDepartmentId: null,

      isBusy: false,
      isExporting: false,
      error: null,
      fields: [
        {key: 'details', label: 'Details', tdClass: 'text-center'},
        {key: 'name', label: 'Abteilung', sortable: true, filter: {type: 'string-contains', value: ''}},
        {
          key: 'budget', label: 'Budget', sortable: true, formatter: ({value}) => this.formatCurrency(value),
          filter: {type: 'decimal-number-contains', value: ''}, filterByFormatted: true,
        },
        {
          key: 'cost', label: 'Kosten', sortable: true, formatter: ({value}) => this.formatCurrency(value),
          tdClass: 'text-end',
          filter: {type: 'decimal-number-contains', value: ''}, filterByFormatted: true,
        },
        {
          key: 'balance', label: 'Restbudget', sortable: true, formatter: ({value}) => this.formatCurrency(value),
          tdClass: 'text-end',
          filter: {type: 'decimal-number-contains', value: ''}, filterByFormatted: true,
        },
      ],
      items: [],
    };
  },
  computed: {
    filteredItems() {
      return this.items.filter((item) => {
        // go through all filters
        return this.fields.filter((field) => field.filter).every((field) => {
          const filter = field.filter;
          // filter for string fields
          if (filter.type === 'string-contains') {
            if (filter.value === '') return true;
            if (field.filterByFormatted) {
              return String(field.formatter({value: item[field.key]})).includes(filter.value.toString());
            } else {
              return String(item[field.key]).toLowerCase().normalize('NFD').replace(/\p{Diacritic}/gu, '')
                  .includes(filter.value.toString().toLowerCase().normalize('NFD').replace(/\p{Diacritic}/gu, ''));
            }
          }
          if (filter.type === 'string-equals') {
            if (filter.value === '') {
              return true;
            }
            if (field.filterByFormatted) {
              return String(field.formatter({value: item[field.key]})) === (filter.value.toString());
            } else {
              return String(item[field.key]).toLowerCase().normalize('NFD').replace(/\p{Diacritic}/gu, '') ===
                  filter.value.toString().toLowerCase().normalize('NFD').replace(/\p{Diacritic}/gu, '');
            }
          }
          if (filter.type === 'decimal-number-contains') {
            if (filter.value === '') {
              return true;
            }
            if (field.filterByFormatted) {
              if (filter.value.includes('.')) {
                return field.formatter({value: item[field.key]})
                    .includes(filter.value);
              } else {
                return field.formatter({value: item[field.key]}).replace(/\./g, '')
                    .includes(filter.value);
              }
            }
          }
          // filter for multiselects
          if (filter.type === 'multiselect') {
            if (!filter.value.length) {
              return true;
            }
            return filter.value.some((filter) => {
              return item[field.key] === filter.id;
            });
          }
        });
      });
    },
    invoiceYears() {
      // compute start year and current year
      const startYear = 2024;
      const currentYear = new Date().getFullYear();
      // return years as string array
      const years = [];
      for (let i = 0; i <= currentYear - startYear; i++) {
        years[i] = startYear + i;
      }
      return years;
    },
  },
  watch: {
    year() {
      this.fetchData();
    },
  },
  mounted() {
    this.fetchData();
    this.calculateContainerHeight();
    window.addEventListener('resize', this.calculateContainerHeight);
  },
  methods: {
    fetchData() {
      this.isBusy = true;
      this.error = false;

      axios.get(this.dataUrl, {
        params: {
          year: this.year,
        },
      }).then((response) => {
        this.items = response.data;
      }).catch((error) => {
        this.error = error;
        this.items = [];
      }).finally(() => {
        this.isBusy = false;
      });
    },
    showDetails(item) {
      this.$refs.table.selection.add(item);
      this.currentDepartmentId = item.id;
    },
    downloadArticles() {
      this.isExporting = true;
      axios.get(this.downloadUrl, {
        params: {
          year: this.year,
        },
        responseType: 'blob',
      }).then((response) => {
        fileDownload(response.data, 'Kostenübersicht ' + this.year + '.xlsx');
      }).finally(() => {
        this.isExporting = false;
      });
    },
    resetFilters() {
      this.fields.filter((field) => field.filter).forEach((field) => field.filter.value = '');
    },
    formatCurrency(value) {
      if (value == null) return '';
      const formatter = new Intl.NumberFormat('de-DE', {style: 'currency', currency: 'EUR'});
      return formatter.format(value);
    },
    calculateContainerHeight() {
      const table = $(this.$refs.table.$el);
      const windowHeight = $(window).height();
      const offsetTop = table.offset().top;
      const footerHeight = $('footer').outerHeight();
      const correction = 18; // due to 1rem margin on footer plus 2px correction to align with department cost container
      const tableHeight = windowHeight - offsetTop - footerHeight - correction;
      table.height(tableHeight);
    },
  },
};
